import type { ReactNode } from 'react'

import { AppShell } from '@/domains/app-shell'
import { OnboardingShell, useSetupState } from '@/domains/setup'

/** picks the shell for /notifications based on the caller's onboarding
 * state. mirrors MessagingShell: users still in onboarding render inside
 * OnboardingShell (onboarding sidebar) so they don't see the
 * post-onboarding nav surface. everyone else gets AppShell.
 */
export function NotificationsShell({
  title,
  children
}: {
  title: ReactNode
  children: ReactNode
}) {
  const { setupState } = useSetupState()
  const inOnboarding = setupState?.isOnboarding ?? false

  if (inOnboarding) {
    return <OnboardingShell title={title}>{children}</OnboardingShell>
  }
  return <AppShell title={title}>{children}</AppShell>
}
